import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useImportLegalMattersMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IImportLegalMatterPreview) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ file, impersonationContext }: { file: File; impersonationContext?: Api.IImpersonationContext }) => {
			const data = new FormData();
			data.append('file', file);

			return userSession.webServiceHelper.callAsync<Api.IImportLegalMatterPreview>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `LegalMatter/importFromFile`,
				}),
				'POST',
				data
			);
		},
		onError,
		onSuccess,
	});
};
